import React from 'react';
import './Footer.css';
const Footer = () => {
  return (
    <footer className="bg-black small text-center">
      <div className="container">Copyright &copy; Motion AR 2019</div>
    </footer>
  );
};

export default Footer;
